import type { ReasoningQuality } from '../../../services/api';

const QUALITY_LABEL: Record<ReasoningQuality, string> = {
  high: 'Razonamiento alto',
  medium: 'Razonamiento medio',
  low: 'Razonamiento bajo',
};

interface MetaBadgesProps {
  confidence?: number;
  reasoningQuality?: ReasoningQuality;
}

/**
 * Muestra la confianza (0..1 → %) y la calidad de razonamiento de una
 * respuesta del asistente, con color según el nivel.
 */
export default function MetaBadges({ confidence, reasoningQuality }: MetaBadgesProps) {
  const hasConfidence = typeof confidence === 'number' && !Number.isNaN(confidence);
  if (!hasConfidence && !reasoningQuality) return null;

  return (
    <div className="meta-row">
      {hasConfidence && (
        <span className="meta-badge">
          <i className="ri-shield-check-line" />
          Confianza {Math.round((confidence as number) * 100)}%
        </span>
      )}
      {reasoningQuality && (
        <span className={`meta-badge quality-${reasoningQuality}`}>
          <i className="ri-brain-line" />
          {QUALITY_LABEL[reasoningQuality]}
        </span>
      )}
    </div>
  );
}
